/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Les_Actief_Actieve_LesInputs */

const nl_les_actief_actieve_les = /** @type {(inputs: Les_Actief_Actieve_LesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actieve les`)
};

/**

* @param {Les_Actief_Actieve_LesInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const les_actief_actieve_les = /** @type {((inputs?: Les_Actief_Actieve_LesInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Les_Actief_Actieve_LesInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_les_actief_actieve_les(inputs)
});
export { les_actief_actieve_les as "les.actief.actieve_les" }